import DepositInterestSettings from "@/models/Products/ProductSettings/DefaultSettings/DepositInterest/DepositInterestSettings";
import CurrencyUtils from "@/lib/currencyUtils";

export default class UpdateDepositInterestSettingsRequest extends DepositInterestSettings {
    updatedAt: Date;

    public constructor(settings: DepositInterestSettings, updatedAt: Date, defaultWalletCurrency: string) {
        super();
        this.updatedAt = updatedAt;
        if (settings) {
            this.overridable = settings.overridable;
            this.enabled = settings.enabled;
            this.interestBearingThreshold.amount = CurrencyUtils.convertDecimalStringToAmountString(settings.interestBearingThreshold.amount);
            this.interestBearingThreshold.currency = defaultWalletCurrency;
            this.accruedPeriodOnDayOfWeek = settings.accruedPeriodOnDayOfWeek;
            this.accruedPeriodOnDayOfMonth = settings.accruedPeriodOnDayOfMonth;
            this.accruedPeriodOnMonth = settings.accruedPeriodOnMonth;
            this.accruedPeriodType = settings.accruedPeriodType;
            this.accruedPeriodValue = settings.accruedPeriodValue;
            this.accruedPeriodValue = +this.accruedPeriodValue
            this.calculatedOnBalanceType = settings.calculatedOnBalanceType;
            this.postingScheduleType = settings.postingScheduleType;
            this.daysInYearType = settings.daysInYearType;
            this.nonWorkingDaysType = settings.nonWorkingDaysType;
            this.postedPeriodOnDayOfWeek = settings.postedPeriodOnDayOfWeek;
            this.postedPeriodOnDayOfMonth = settings.postedPeriodOnDayOfMonth;
            this.postedPeriodOnMonth = settings.postedPeriodOnMonth;
            this.postedPeriodType = settings.postedPeriodType;
            this.postedPeriodValue = settings.postedPeriodValue;
            this.postedPeriodValue = +this.postedPeriodValue;
            this.rateType = settings.rateType;
            this.rateValue = settings.rateValue;
            this.rateValue = +this.rateValue;
            this.rateSourceId = settings.rateSourceId;
        }
    }
}